export default {
    index: {
        title: '내 정보',
        tab: {
            general: '일반',
            classroom: '학급 정보',
        },
    },
    form: {
        title: '계정',
        label: {
            loginId: '아이디',
            name: '이름',
            createdAt: '가입일',
            school: '학교',
            phone: '전화번호',
        },
        schoolPlaceholder: '학교검색을 해주세요',
    },
    modal: {
        check: {
            title: '변경사항 확인',
            message: '변경된 정보가 저장되지 않습니다.\n계속 진행하시겠습니까?',
            exitWithoutSave: '저장하지 않고 나가기',
            saveAndExit: '저장 후 나가기',
        },
    },
    schoolSearch: {
        title: '학교 검색',
        description: {
            prefix: '목록에는 최대 100개까지만 표시됩니다. 보이지 않는 경우,\n',
            suffix: '학교명을 직접 입력해 주세요.',
        },
        searchPlaceholder: '학교명 검색',
        emptyMessage: '검색 결과가 없습니다.',
    },
    changePhone: {
        title: '전화번호 변경',
        placeholder: '휴대폰 번호를 입력해주세요',
    },
    serviceInfo: {
        title: '이용 기간',
        days: '일 남음',
        expired: '(만료됨)',
        students: '이용 인원',
        maxStudents: '최대 정원 {count}명',
        contact: '<strong>이용 기간 연장 및 인원 변경</strong>을 원하시는 경우 ',
        contactLink: {
            prefix: '여기',
            suffix: '를 클릭해 문의해주세요.',
        },
        contactKakao: {
            prefix: '매일국어T 카카오톡 채널',
            suffix: '로 연결돼요.',
        },
    },
    classroom: {
        title: '학급 정보',
        register: '학급 등록',
        tab: {
            general: '일반',
            classroom: '학급 정보',
        },
        main: '메인 학급',
        modal: {
            delete: '학급 삭제',
            deleteMessage: '해당 학급을 삭제하시겠습니까?',
            deleteMessage2: '삭제 시 복구 되지 않습니다.',
            saveConfirm: '학급 정보를 수정하시겠습니까?',
            saveConfirmTitle: '학급 정보 수정',
            changeClassNameTitle: '학급명 변경',
            changeTitle: '메인 학급 변경',
            changeMessage: '현재 설정된 메인 학급을 [{className}] (으)로 변경하시겠습니까?',
        },
        form: {
            title: '학급 등록',
            label: {
                schoolYear: '학년도',
                grade: '학년',
                className: '학급 이름',
                elementary: '초등학교 {grade}학년',
                gradePlaceholder: '학년을 선택해주세요',
                classNamePlaceholder: '2~8자 이내 ex. 3반, 에너지뿜뿜',
            },
        },
        table: {
            select: '선택',
            schoolYear: '학년도',
            grade: '학년',
            className: '학급',
            studentsCount: '학생수',
            code: '학급 코드',
            createdAt: '등록일',
            updatedAt: '최근 수업일',
            main: '메인 학급',
        },
        button: {
            change: '메인 학급으로 변경',
        },
    },
};
